// extracted by mini-css-extract-plugin
export default {"dialogPaper":"AddSponsorModal_dialogPaper__31gX0","footer":"AddSponsorModal_footer__qtf+Z"};